export const tinymce = {
    height: 400,
    menubar: false,
    plugins: [
      "advlist autolink lists link image",
      "charmap preview anchor help",
      "searchreplace visualblocks code",
      "insertdatetime media table wordcount",
    ],
    toolbar:
      "undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | help",
  }